module.exports = __webpack_public_path__ + "static/media/Asian_RewardBackground.2177a12e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Asian_RewardBackground.png
// module id = 1353
// module chunks = 3